import Image from 'next/image';
import { FaQuoteLeft } from 'react-icons/fa';
import avatar from '@assets/images/avatar.png'; // temp
import vikas from '@assets/bytes/vikas-footer.png';
import Link from 'next/link';
import { Primary } from 'stories/Button.stories';

const BytesFooter = () => {
  return (
    <footer className="relative !mx-0 font-satoshi-medium  md:mx-0">
      <div className="grid grid-cols-1 gap-x-7 space-y-7 overflow-hidden bg-[linear-gradient(114.85deg,_#2c2c2c_12.56%,_#000000_88.34%)] px-6 pt-6 shadow-md md:grid-cols-2 md:rounded-none md:shadow-none lg:grid-cols-[1.2fr_2fr] lg:space-y-0 lg:px-28 lg:pb-6">
        <div className="flex flex-col items-start justify-center font-satoshi-medium  text-white">
          <FaQuoteLeft className="text-red" />
          <p className="mb-6 font-satoshi-medium text-[0.9rem] font-light leading-5 tracking-normal md:text-lg">
            AlmaBetter’s curriculum is the best curriculum available online. AlmaBetter’s program is
            engaging, comprehensive, and student-centered. If you are honestly interested in Data
            Science, you cannot ask for a better platform than AlmaBetter.
          </p>
          <div className="ml-auto">
            <div className="flex items-end gap-x-2">
              <div className="relative h-10 w-10">
                <Image
                  src={avatar}
                  alt="avatar"
                  layout="fill"
                  objectFit="contain"
                  className="rounded-full"
                />
              </div>
              <div className="space-y-1">
                <div className="font-satoshi-medium text-xs font-semibold md:text-base">
                  Kamya Malhotra
                </div>
                <div className="font-satoshi-medium text-xs font-medium  text-bytes-red-3">
                  Statistical Analyst
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="relative">
          <div className="absolute -bottom-2 hidden h-full lg:block">
            <div className="relative aspect-square h-full">
              <Image src={vikas} alt="Vikas CTO" layout="fill" className="w-full object-contain" />
            </div>
          </div>

          <div className="flex h-full items-center justify-end">
            <div className="flex w-full flex-col items-center bg-white px-5 py-8 text-center lg:w-8/12">
              <div className="mb-6 w-10/12 text-center font-satoshi-medium text-xl font-medium  leading-6 md:mx-auto md:mb-8 md:text-[2.265rem] md:leading-[3.125rem]">
                Fast forward your career in tech with{' '}
                <strong className="font-satoshi-medium font-semibold">AlmaBetter</strong>
              </div>
              <Primary
                linkCTA
                href="https://www.almabetter.com/courses"
                label="Explore Courses"
                size="2xl"
                customStyle="w-11/12"
                capitalCase
              />
              {/* <Link
                href="https://www.almabetter.com/courses"
                as="https://www.almabetter.com/courses"
                passHref
              >
                <a className="w-11/12 bg-red py-2.5 font-satoshi-medium text-bytes-sm normal-case text-white md:text-xl md:leading-10">
                  Explore Courses
                </a>
              </Link> */}
            </div>
          </div>
        </div>
        <div className="relative lg:hidden">
          <p className="absolute bottom-4 z-40 w-6/12 font-satoshi-medium font-satoshi-medium font-semibold text-white">
            Vikash Srivastava
            <span className="inline-block font-satoshi-medium  text-[0.85rem] font-light leading-5">
              Co-founder & CPTO AlmaBetter
            </span>
          </p>
          <div className="ml-auto w-9/12">
            <img
              src={'/assets/bytes/vikas-footer-2.png'}
              alt="Vikas CTO"
              loading="lazy"
              className="object-contain"
            />
          </div>
        </div>
      </div>
    </footer>
  );
};

export default BytesFooter;
